import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { query, where, collection, onSnapshot, doc, getDocs } from "firebase/firestore";
import { db } from "../../firebase.js";
import Cookies from "js-cookie";
import { Toast } from '../../components_root/ToastContext';
import { PiBooks } from "react-icons/pi";
import { MdAccountCircle, MdManageAccounts, MdSave, MdSearch } from "react-icons/md";
import { Save_ledger_account } from "./save_ledger_account.js";
import logo_default from "../../assets/logo_default.jpg";
import Ledger_accounts_profile from "../../company_root/staff_account_root/ledger_accounts_profile.jsx";
export const seo = {
    title: "aooz Services | Free & Premium Online Tools for Productivity, SEO & File Conversion",
    Description: "Discover aooz's free and premium online services including word counter, image to PDF, favicon generator, SEO analyzers, text utilities, and more. Enhance productivity with powerful tools for students, writers, developers, and businesses.",
    keywords: "aooz services, free online tools, premium tools, seo tools, text utilities, file converters, image to pdf, favicon generator, word counter, productivity tools, online converters",
    url: "https://aooz.in/services",
    image: "https://aooz.in/assets/logo.png"
};
export default function Create_ledger_accounts() {
    const [accounts_name, setAccounts_name] = useState("");
    const [description, setDescription] = useState("");
    const [mobile, setMobile] = useState("");
    const { Toastshow } = Toast();
    const navigate = useNavigate();
    const [IsLoading2, setIsLoading2] = useState(true);
    const [slug, setSlug] = useState("");
    const servicetablename = "accountingfinancedb";
    const [account_type, setAccount_type] = useState("");
    const [accountguid, setaccountguid] = useState("");
    const [photoURL, setPhotoURL] = useState(""); 
    const [searchstatus, setSearchstatus] = useState(false);
    const [error_msg, setError_msg] = useState(""); 
    const handleCreate = async () => {
        if (!account_type || !account_type.trim()) {
            Toastshow("Please Select role type.");
            return;
        }
        if (!description || !description.trim()) {
            Toastshow("Please enter Description.");
            return;
        }
        const data = {
            accountguid,
            usecase: true,
            slug,
            description: description,
            account_type:account_type,
            // Add other necessary fields here
        };
        const result = await Save_ledger_account(data);
        if (result.success) {
            setAccounts_name("");
            setDescription("");
            Toastshow("Voucher saved successfully.");

        } else {
            Toastshow(result.error || "Failed to save voucher.");
        }
    };
    const handle_search_accountguid = async (mobile) => {
        const select_company_uid = Cookies.get("select_company_uid");

        const servicetablename = "companies";
        if (!select_company_uid || select_company_uid === "undefined" || select_company_uid === "null" || mobile.length < 7 && mobile == null) {
            setError_msg("");
            setaccountguid("");
            setAccount_type("");
            setPhotoURL("");
            setDescription("");
            return { success: false, error: "Contact service provider." };

        }

        const checkQuery = query(
            collection(db, "accounts"),
            where("mobile", "==", mobile)
        );
        const checkSnap = await getDocs(checkQuery);

        if (!checkSnap.empty) {
            const ledgerCollection = collection(
                db,
                servicetablename,
                select_company_uid,
                "staff_accounts"
            );
            const userDoc = checkSnap.docs[0];
            const userData = userDoc.data();
            setaccountguid(userData.guid);
            setPhotoURL(userData.photoURL);
            setDescription(userData.address + ", " + userData.city);
            const Query = query(
                ledgerCollection,
                where("status", "==", true),
                where("accountguid", "==", userData.guid),
            );
            const Snap = await getDocs(Query);
            if (Snap.empty) {
                setError_msg("First add this account in the company");
                return;
            }
            setError_msg("");
            const Doc = Snap.docs[0];
            const Data = Doc.data();
            setSearchstatus(true);
            // ✅ Existing User: skip creating
            setAccount_type(Data.account_type);

        } else {
            setError_msg("This mobile account does not exist");
            setSearchstatus(false);
        }
    }


    const [accounting_groups_raw, setaccounting_groups_raw] = useState([]);

    useEffect(() => {
        const masterQuery = query(
            collection(db, "accounting_groups_list_master")
        );

        const unsubscribeMaster = onSnapshot(masterQuery, (snapshot) => {
            const rawList = snapshot.docs.map((d) => d.data());

            setaccounting_groups_raw(rawList); // 👈 keep raw
            setIsLoading2(false);
        });

        return () => unsubscribeMaster();
    }, []);

    const normalize = (slug = "") => {
        return slug
            .replace(/^https?:\/\//i, "")   // remove http:// or https://
            .replace(/\/+$/, "")            // remove trailing slash
            .replace(/[^a-zA-Z0-9]/g, "")   // remove ALL special characters
            .toLowerCase();                 // make lowercase
    };
    return (
        <div >
            <div className="items-back b-1 rounded p-2">
                <table>
                    <tr>
                        <td><div className="text-h2 bold">Create ledger account </div></td>
                    </tr>
                    <tr>
                        <td className="text-h3 text-off">How to get mobile from the account profile</td>
                    </tr>
                    <tr>
                        <td><div className="text-h2 center red m-1">{error_msg}</div></td>
                    </tr>
                    <tr>
                        <td>
                            {accountguid && accountguid.length >= 15 && (
                                <Ledger_accounts_profile accountguid={accountguid} />
                            )}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            Reg id:- {accountguid}
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <table>
                                <tr>

                                    <td>

                                        <input type="text" className="p-2" onChange={(e) => {
                                            let val = e.target.value;
                                            if (val.length >= 10) {
                                                handle_search_accountguid(e.target.value);
                                            } else {
                                                setError_msg("");
                                                setaccountguid("");
                                                setAccount_type("");
                                                setPhotoURL("");
                                                setDescription("");
                                            }

                                        }}

                                            maxLength={50} placeholder="Enter mobile number" />
                                    </td>

                                </tr>
                            </table>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <select
                                value={account_type}
                                onChange={(e) => setAccount_type(e.target.value)}
                                className="text-h2 bold p-2"
                            >
                                <option value="">Select account</option>

                                {accounting_groups_raw.reduce((acc, item) => {
                                    const key = `${item.group}_${item.group_title}`;

                                    if (!acc[key]) {
                                        acc[key] = {
                                            label: `${item.group_title} (${item.group})`,
                                            items: []
                                        };
                                    }

                                    acc[key].items.push(item);
                                    return acc;
                                }, {}) &&
                                    Object.values(
                                        accounting_groups_raw.reduce((acc, item) => {
                                            const key = `${item.group}_${item.group_title}`;

                                            if (!acc[key]) {
                                                acc[key] = {
                                                    label: `${item.group_title} (${item.group})`,
                                                    items: []
                                                };
                                            }

                                            acc[key].items.push(item);
                                            return acc;
                                        }, {})
                                    ).map((group) => (
                                        <optgroup key={group.label} label={group.label}>
                                            {group.items.map((item) => (
                                                <option
                                                    key={item.groupid}
                                                    value={item.groupid}   // ✅ THIS IS WHAT YOU WANT
                                                >
                                           <div className="fcap">{item.account_type.replaceAll("_", " ")}</div>
                                                </option>
                                            ))}
                                        </optgroup>
                                    ))}
                            </select>

                        </td>
                    </tr>
                    <tr>
                        <td><div className="text-h2 bold">Description</div></td>
                    </tr>
                    <tr>
                        <td><textarea className="p-2" value={description} onChange={(e) => setDescription(e.target.value)} maxLength={200} placeholder="Enter description" /></td>
                    </tr>
                </table>
                {searchstatus == true ? (
                    <div className="button-ui green-back p-22 fill text-h2    cursor" onClick={() => handleCreate()}><MdSave className="icon" />Create account</div>

                ) : (<div className="button-ui p-22 fill text-h2 fcap  cursor" onClick={() => handle_search_accountguid(accountguid)}><MdSearch className="icon" />Search now</div>)}

            </div>
        </div>
    );
}
